import { render, staticRenderFns } from "./DashboardControlBar.vue?vue&type=template&id=3e9a3670&scoped=true"
import script from "./DashboardControlBar.vue?vue&type=script&lang=js"
export * from "./DashboardControlBar.vue?vue&type=script&lang=js"
import style0 from "./DashboardControlBar.vue?vue&type=style&index=0&id=3e9a3670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9a3670",
  null
  
)

export default component.exports